export default __webpack_public_path__ + "static/media/cases5.936cb2fc.jpg";